import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Mail = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="28.283" height="22.398" viewBox="0 0 28.283 22.398">
      <g id="mail" transform="translate(0.393)">
        <path id="Tracé_437" data-name="Tracé 437" d="M4.55,4h20.4A2.557,2.557,0,0,1,27.5,6.55v15.3a2.557,2.557,0,0,1-2.55,2.55H4.55A2.557,2.557,0,0,1,2,21.849V6.55A2.557,2.557,0,0,1,4.55,4Z" transform="translate(-1 -3)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <path id="Tracé_438" data-name="Tracé 438" d="M27.5,6,14.749,14.924,2,6" transform="translate(-1 -2.45)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Mail;